if (!customElements.get('cp-service-directory')) {
  customElements.define('cp-service-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const cards = [...this.querySelectorAll('[data-service-group]')];
      const buttons = [...this.querySelectorAll('[data-filter]')];
      const status = this.querySelector('.cp-service-count');
      const controls = this.querySelector('.cp-directory-tools');
      const apply = (selected) => {
        let count = 0;
        cards.forEach(card => {
          const visible = selected === 'all' || card.dataset.serviceGroup === selected;
          card.hidden = !visible;
          if (visible) count++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === selected)));
        status.textContent = `${count} ${count === 1 ? 'service' : 'services'} to explore`;
      };
      buttons.forEach(button => button.addEventListener('click', () => apply(button.dataset.filter)));
      apply('all');
      controls.hidden = false;
    }
  });
}
